import React, { useEffect, useState, useCallback } from "react";
import API from "../api";
import Layout from "../components/Layout";
import "../css/style.css";
import {
    FaRupeeSign,
    FaFileInvoice,
    FaUsers,
    FaBoxOpen,
    FaTruck,
    FaStore
} from "react-icons/fa";

const Dashboard = () => {

    const [data, setData] = useState({});
    const [revenue, setRevenue] = useState({});
    const [orders, setOrders] = useState([]);

    const [search, setSearch] = useState("");
    const [limit, setLimit] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);

    const loadAll = useCallback(async () => {
        try {
            const [stats, rev, ord] = await Promise.all([
                API.get("/dashboard"),
                API.get("/dashboard/advanced"),
                API.get("/dashboard/orders"),
            ]);

            setData(stats.data || {});
            setRevenue(rev.data || {});
            setOrders(ord.data || []);
        } catch (err) {
            console.log(err);
        }
    }, []);

    useEffect(() => {
        loadAll();
    }, [loadAll]);

    const filteredOrders = (orders || []).filter((o) =>
        o.customerName?.toLowerCase().includes(search.toLowerCase())
    );

    // PAGINATION
    const perPage = Number(limit);
    const indexOfLast = currentPage * perPage;
    const indexOfFirst = indexOfLast - perPage;
    const currentOrders = filteredOrders.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(filteredOrders.length / perPage);

    const changePage = (num) => {
        setCurrentPage(num);
    };

    // RESET PAGE
    useEffect(() => {
        setCurrentPage(1);
    }, [search, limit]);

    return (
        <Layout>

            {/* CARDS */}
            <div className="cards">

                <Card1 title="Today Sales" value={`₹${Number(data.todaySales || 0).toFixed(2)}`} color="green" icon={<FaRupeeSign />} />
                <Card1 title="Current Month Sales" value={`₹${Number(revenue.currentMonthSales || 0).toFixed(2)}`} color="red" icon={<FaRupeeSign />} />
                <Card1 title="Last 3 Months Record Sales" value={`₹${Number(revenue.last3MonthSales || 0).toFixed(2)}`} color="yellow" icon={<FaRupeeSign />} />
                <Card1 title="Last 6 Months Record Sales" value={`₹${Number(revenue.last6MonthSales || 0).toFixed(2)}`} color="gray" icon={<FaRupeeSign />} />
                <Card1 title="Total Revenue" value={`₹${Number(revenue.totalRevenue || 0).toFixed(2)}`} color="blue" icon={<FaRupeeSign />} />


                <Card1 title="Invoices" value={data.todayInvoice || 0} color="yellow" icon={<FaFileInvoice />} />
                <Card1 title="Customers Enquery List" value={data.totalUsers || 0} color="gray" icon={<FaUsers />} />
                <Card1 title="Products" value={data.totalProducts || 0} color="blue" icon={<FaBoxOpen />} />

                <Card1 title="Suppliers" value={data.totalSuppliers || 0} color="purple" icon={<FaTruck />} />
                <Card1 title="Stores" value={data.totalStores || 0} color="orange" icon={<FaStore />} />

            </div>

            {/* TABLE */}
            <div className="table-section">
                <h3>Today's Transactions</h3>

                <div className="table-controls">
                    <div>
                        Show{" "}
                        <select value={limit} onChange={(e) => setLimit(Number(e.target.value))}>
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                        </select>{" "}
                        entries
                    </div>

                    <div>
                        Search:{" "}
                        <input
                            type="text"
                            placeholder="Search customer..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </div>
                </div>

                <div className="table-responsive">
                    <table>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Customer</th>
                                <th>Payment</th>
                                <th>Amount</th>
                                <th>Status</th>
                            </tr>
                        </thead>

                        <tbody>
                            {currentOrders.length > 0 ? (
                                currentOrders.map((o) => (
                                    <tr key={o._id}>
                                        <td>{o._id.slice(-5)}</td>
                                        <td>{o.customerName}</td>
                                        <td>{o.paymentMethod}</td>
                                        <td>₹{o.totalAmount}</td>
                                        <td>
                                            <span className={`status ${o.status.toLowerCase()}`}>
                                                {o.status}
                                            </span>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5">No data available</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* PAGINATION */}
                <div className="pagination">
                    <button
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage(currentPage - 1)}
                    >
                        Prev
                    </button>

                    {Array.from({ length: totalPages }, (_, i) => (
                        <button
                            key={i}
                            onClick={() => changePage(i + 1)}
                            className={currentPage === i + 1 ? "active" : ""}
                        >
                            {i + 1}
                        </button>
                    ))}

                    <button
                        disabled={currentPage === totalPages}
                        onClick={() => setCurrentPage(currentPage + 1)}
                    >
                        Next
                    </button>
                </div>

            </div>

        </Layout>
    );
};

const Card1 = ({ title, value, color, icon }) => (
    <div className={`card1 ${color}`}>
        <div className="card-top">
            <div>
                <p>{title}</p>
                <h2>{value}</h2>
            </div>

            <div className="card-icon">
                {icon}
            </div>
        </div>
    </div>
);

export default Dashboard;


